<template lang="pug">
#cliam_settlement_info
  section.container
    h2.i_h2_title.text-center.i_mt_10.i_mb_8 {{ productDetail.ClaimInfo_area01_Title }}
    p.i_body_l.text-center {{ productDetail.ClaimInfo_area01_SubTitle }}

    .timeline.i_mt_8.d-flex.flex-column.flex-md-row.justify-content-center(
      v-if="$store.state.screenWidth > 767 || ($store.state.screenWidth < 768 && isCollapseExpand)"
    )
      timeline-item.flex-grow-1(
        v-for="(timelineItem, index) in productDetail.ClaimInfo_area01_StepContent",
        :key="index",
        :title="timelineItem.area01_StepContent_Title",
        :content="timelineItem.area01_StepContent_Content",
        :icon="timelineItem.area01_StepContent_icon"
      )
    .timeline.i_mt_8.d-flex.flex-column.flex-md-row.justify-content-center(
      v-if="$store.state.screenWidth < 768 && !isCollapseExpand"
    )
      timeline-item.flex-grow-1(
        v-if="index < 2",
        v-for="(timelineItem, index) in productDetail.ClaimInfo_area01_StepContent",
        :key="index",
        :title="timelineItem.area01_StepContent_Title",
        :content="timelineItem.area01_StepContent_Content",
        :icon="timelineItem.area01_StepContent_icon"
      )
  section.container(
    v-if="productDetail.ClaimInfo_area01_DetailStep == 1 && ($store.state.screenWidth > 767 || (width < 768 && isCollapseExpand))"
  )
    .row.text-center.i_mt_8(v-if="$store.state.screenWidth > 767")
      .collapse_btn(
        @click="isCollapseExpand = !isCollapseExpand",
        :class="{ expand: isCollapseExpand }"
      ) {{ isCollapseExpand ? collapseText[1] : collapseText[0] }}
    .step_line.fade.i_mt_8.d-flex.flex-column.flex-md-row.justify-content-center(
      v-if="isCollapseExpand"
    )
      step-line-item.flex-grow-1(
        v-for="(stepLineItem, index) in productDetail.ClaimInfo_area01_DetailStepContent",
        :key="index",
        :title="stepLineItem.area01_DetailStepContent_Title",
        :icon="stepLineItem.area01_DetailStepContent_icon"
      )

  .cover_gradient.text-center(
    v-if="$store.state.screenWidth < 768",
    :class="{ expand: isCollapseExpand }"
  )
    .collapse_btn(
      @click="isCollapseExpand = !isCollapseExpand",
      :class="{ expand: isCollapseExpand }"
    ) {{ isCollapseExpand ? collapseText[1] : collapseText[0] }}
  section.i_pb_8
    expand-head.i_mt_12(
      @click.native="setCliamFileExpand",
      :title="cliamFileTitle",
      :icon="'ic_QA_document'",
      :selected="cliamFileExpand"
    )
    doc-descriptions.fade.i_mt_10.i_mt_md_6.i_mt_sm_4(
      v-if="cliamFileExpand",
      :docDescriptions="productDetail"
    )

  section
    expand-head.i_mt_6(
      @click.native="setRelatedQuesExpand",
      :title="relatedQuesTitle",
      :icon="'ic_QA_compensation'",
      :selected="relatedQuesExpand"
    )
    transition(name="fade-height")
      .container(v-show="relatedQuesExpand")
        .related_ques_content(
          v-for="(QuestionContent, index) in currentQAList",
          :key="index"
        )
          qa-html-item.i_pt_6(:QuestionContent="QuestionContent")
        .row
          .col-12.text.center.justify-content-center
            b-pagination(
              v-model="currentPage",
              :total-rows="totalRows",
              :per-page="perPage",
              first-number,
              last-number
            )
    .container.i_mt_6.i_mb_10
      router-link.btn_round(
        v-if="true",
        tag="a",
        :to="{ name: 'CustomerServiceContactUs' }",
        :class="{ btn_blue: $store.state.navigationStyle == 2 }"
      ) 聯絡我們
</template>

<script>
import TimelineItem from "@/components/customer_service/TimelineItem";
import StepLineItem from "@/components/customer_service/StepLineItem";
import ExpandHead from "@/components/common/ExpandHead";
import DocDescriptions from "@/components/product/BusinessCliamSettlementInfo/DocDescriptions";
import QAHtmlItem from "@/components/customer_service/QAHtmlItem";
import { getFAQDetail } from "@/json/FAQ";

export default {
  name: "CliamSettleInfo",
  components: {
    "timeline-item": TimelineItem,
    "step-line-item": StepLineItem,
    "expand-head": ExpandHead,
    "qa-html-item": QAHtmlItem,
    "doc-descriptions": DocDescriptions,
  },
  props: {
    productDetail: Object,
  },
  data() {
    return {
      relatedQuesTitle: "保險內容相關問題",
      relatedQuesExpand: true,
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
      currentQAList: [],
      QAList: [],

      isCollapseExpand: false,
      collapseText: ["觀看細部步驟", "收起細部步驟"],

      cliamFileTitle: "理賠必備文件",
      cliamFileIcon: "",
      cliamFileExpand: true,
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  created() {
    this.getFAQDetail();
  },
  methods: {
    setCliamFileExpand() {
      this.cliamFileExpand = !this.cliamFileExpand;
    },
    setRelatedQuesExpand() {
      this.relatedQuesExpand = !this.relatedQuesExpand;
    },
    expand() {
      this.isExpand = !this.isExpand;
    },
    getFAQDetail() {
      getFAQDetail().then((response) => {
        let FAQDetail = response.data.FAQDeatilList;
        for (let x in FAQDetail) {
          let detail = FAQDetail[x];
          if (
            this.productDetail.ClaimInfo_area03_FAQCategoryID ==
            detail.FAQCategoryID
          ) {
            this.QAList.push(detail);
          }
        }
        this.totalRows = this.QAList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentQAList = [];
      let number = this.perPage * this.currentPage;
      this.currentQAList = this.QAList.slice(number - this.perPage, number);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/timeline_stepline";
@import "@/assets/style/common/pagination";

.cover_gradient {
  width: 100%;
  height: 200px;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    #ffffff 20%
  );
  position: absolute;
  transform: translateY(-35vw);

  .collapse_btn {
    margin-top: 50px;
  }
}

.cover_gradient.expand {
  background-image: none;
  transform: none;
  position: relative;
  height: auto;
}

h2.i_h2_title {
  color: $color_blue_btn;
}

::v-deep .title_bar {
  background-color: $color_blue;
}

::v-deep .page-item.active .page-link {
  color: $color_blue;
}
</style>
